/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const v = 'is-visible';
	const h = 'is-hide';

	const setInquiryType = () => {
		const inquiryType = document.getElementsByClassName("js-inquiry_type")[0];
		const inquiryTypeSet = () => {
			if (inquiryType.value === "") {
				const inquiryAllItem = document.querySelectorAll(".contact-item")
				const inquiryAllLabel = document.querySelectorAll(".contact-controlled_label")
				inquiryAllItem.forEach(element => {
					element.classList.remove(v)
				});
				inquiryAllLabel.forEach(element => {
					element.classList.remove(h)
				});
			} else {
				const inquiryAllItem = document.querySelectorAll(".contact-item")
				const inquiryItem = document.querySelectorAll("." + inquiryType.value)
				const inquiryAllLabel = document.querySelectorAll(".contact-controlled_label")
				const inquiryLabel = document.querySelectorAll("." + inquiryType.value + "-label")

				inquiryAllLabel.forEach(element => {
					element.classList.remove(h)
				});
				inquiryLabel.forEach(element => {
					element.classList.add(h)
				});
				inquiryAllItem.forEach(element => {
					element.classList.remove(v)
				});
				inquiryItem.forEach(element => {
					element.classList.add(v)
				});
			}
		}

		// お問い合わせの種類　変更時
		inquiryType.addEventListener("change", () => {
			inquiryTypeSet();
		})

		// 確認画面から戻ってきたとき
		window.onload = function() {
			inquiryTypeSet();
		}
	}

	setInquiryType();


})(window.FUNCTIONS);
